import { useMatches } from 'react-router';

import useRootData from '~/hooks/useRootData';
import useUser from '~/hooks/useUser';

export default function useIsSignedIn() {
  const user = useUser();
  const { hasAccountCookie } = useRootData();
  const page = useMatches().at(-1)?.data as { userData?: unknown } | undefined;

  return page?.userData ? user.isLoggedIn : hasAccountCookie;
}
